<template>
  <div class="team-info">
    <div class="box-shadow-container">
      <div class="base-desc">
        <div class="title">
          {{ dataSource.name.value }}
        </div>
        <div class="desc">
          {{ dataSource.desc.value }}
        </div>
      </div>
      <div class="list">
        <div class="scroll-wrapper" ref="scroll">
          <div class="scroll-content">
            <template v-for="key in Object.keys(dataSource.member)">
              <a
                class="item"
                :key="key"
                :href="dataSource.member[key].link.value"
                v-if="dataSource.member[key].cover.hasValue && dataSource.member[key].cover.value"
                target="_blank"
              >
                <img class="cover" :src="dataSource.member[key].cover.value" />
                <div class="name" :style="getStyle(dataSource.member[key].link.value)">
                  {{ dataSource.member[key].name.value }}
                </div>
              </a>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "@better-scroll/core";

export default {
  name: "TeamInfo",
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      bs: null
    };
  },
  computed: {
    isCurrent() {}
  },
  watch: {
    dataSource: {
      handler(val) {
        this.initBS();
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.initBS();
    }, 500);
  },
  methods: {
    initBS() {
      this.bs = new BScroll(this.$refs.scroll, {
        scrollX: true,
        probeType: 3
      });
    },
    getStyle(link) {
      const id = this.$route.params.id;
      const target = link.match(/\d+(?=.html)/);
      if (target && target[0] !== id)
        return {
          "font-weight": "bold",
          color: "#3EAFFE"
        };
      return {};
    }
  }
};
</script>

<style lang="less" scoped>
.team-info {
  width: 671px;
  height: 278px;
  background: url("~@/assets/nikke_imgs/team-bg.png") center/100% 100% no-repeat;
  /* box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.15), inset 8px -8px 8px 0px #ffffff, inset -8px 8px 8px 0px #ffffff; */
  border-radius: 4px;
  /* border: 1px solid #ffffff; */
  padding: 20px 28px;
  .box-shadow-container {
    background-color: rgba(244, 244, 244, 0.6);
  }
  .base-desc {
    width: 100%;
    min-height: 40px;
    position: relative;
    margin-bottom: 20px;
    .title {
      position: relative;
      color: #142630;
      font-size: 13px;
      font-weight: bold;
      width: fit-content;
      margin-left: 40px;
      margin-bottom: 12px;
      &::before {
        content: "";
        position: absolute;
        width: 24px;
        height: 3px;
        left: -40px;
        bottom: 6px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("~@/assets/nikke_imgs/skill-detail-shengji.png");
      }
      &::after {
        content: "";
        position: absolute;
        width: 436px;
        height: 1px;
        right: -444px;
        bottom: 6px;
        background: linear-gradient(90deg, rgba(65, 79, 108, 0.7) 0%, rgba(126, 154, 210, 0) 100%);
      }
    }
    .desc {
      font-weight: 500;
      font-size: 12px;
      color: rgba(51, 51, 51, 0.9);
      line-height: 16px;
    }
  }
  .list {
    width: 100%;
    padding: 0 10px;
  }
  .scroll-wrapper {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    padding-bottom: 10px;
    .scroll-content {
      display: inline-block;
    }
    .item {
      position: relative;
      display: inline-block;
      width: 104px;
      height: 126px;
      margin-right: 26px;
      .cover {
        width: 100%;
      }
      .name {
        position: absolute;
        bottom: -24px;
        left: 0;
        width: 100%;
        font-weight: 500;
        font-size: 11px;
        color: #000000;
        text-align: center;
        padding: 0 6px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .link {
        position: absolute;
        top: 0px;
        right: 0px;
        width: 24px;
        height: 24px;
        background: #1a88dd;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
